import { render, staticRenderFns } from "./Scrollable.vue?vue&type=template&id=23c5182a&scoped=true&"
import script from "./Scrollable.vue?vue&type=script&lang=js&"
export * from "./Scrollable.vue?vue&type=script&lang=js&"
import style0 from "./Scrollable.vue?vue&type=style&index=0&id=23c5182a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c5182a",
  null
  
)

export default component.exports